// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"PageHeader_pageHeader__lnnFR","title":"PageHeader_title__lishD"};